import { atom, useRecoilValue } from 'recoil'
import { responseLookupServiceTypes } from '../../services/lookup/types'
import * as RESServiceType from '../../services/web/types/responseWebServiceTypes'
export type ManageProjectStoreType = {
    projectData: RESServiceType.GetProjectResultType | null | undefined
    documentTopic: responseLookupServiceTypes.ResultDocumentTopicLut[] | null
    parameterForSave: any

    currentPageUpdater?: {
        name_th: string
        name_en: string
        date: string //"YYYY-MM-DDTHH:mm:ss"
    } | null
}
export const manageProjectStore = atom<ManageProjectStoreType>({
    key: 'manageProjectStore',
    default: {
        projectData: null,
        documentTopic: null,
        parameterForSave: null,
        currentPageUpdater: null, //คนที่อัปเดตล่าสุดในแต่ละ Tab ที่เปิดอยู่
    },
})

const useManageProjectStore = () => {
    const appAlertMessageState = useRecoilValue(manageProjectStore)
    return {
        ...appAlertMessageState,
    }
}

export default useManageProjectStore
